import { useEffect, useState } from "react";
import { useLang } from "../i18n/LanguageContext";
import { scrollToId } from "./SmoothScroll";

const CITIES = [
  { src: "/img/rome.jpg", label: "ROMA" },
  { src: "/img/paris.jpg", label: "PARIS" },
  { src: "/img/nyc.jpg", label: "NEW YORK" },
  { src: "/img/dubai.jpg", label: "DUBAI" },
  { src: "/img/singapore.jpg", label: "SINGAPORE" },
  { src: "/img/sydney.jpg", label: "SYDNEY" },
  { src: "/img/rio.jpg", label: "RIO DE JANEIRO" },
  { src: "/img/cairo.jpg", label: "CAIRO" },
  { src: "/img/london.jpg", label: "LONDON" },
];

const ZONES = [
  ["ROMA", "Europe/Rome"],
  ["LONDON", "Europe/London"],
  ["NEW YORK", "America/New_York"],
  ["DUBAI", "Asia/Dubai"],
  ["SINGAPORE", "Asia/Singapore"],
  ["SYDNEY", "Australia/Sydney"],
  ["RIO", "America/Sao_Paulo"],
  ["CAIRO", "Africa/Cairo"],
];

const Star = ({ className = "text-[var(--fux)]" }) => (
  <svg viewBox="0 0 24 24" className={`w-4 h-4 shrink-0 self-center ${className}`} aria-hidden="true">
    <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" fill="currentColor" />
  </svg>
);

const Clocks = () => {
  const { t, lang } = useLang();
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const iv = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(iv);
  }, []);
  const fmt = (tz) => {
    try {
      return new Intl.DateTimeFormat(lang === "en" ? "en-GB" : lang, { hour: "2-digit", minute: "2-digit", timeZone: tz }).format(now);
    } catch {
      return "--:--";
    }
  };
  const items = [[t.global.timezones, null], ...ZONES];
  const doubled = [...items, ...items];
  return (
    <div data-testid="timezones-bar" className="mt-6 pt-4 border-t border-[rgba(16,16,20,0.1)] overflow-hidden">
      <div className="marquee-track" style={{ animationDuration: "35s" }}>
        {doubled.map(([city, tz], i) =>
          city === t.global.timezones ? (
            <span key={i} className="mono text-[11px] uppercase text-[var(--fux)] flex items-center gap-2 pr-8 shrink-0">
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--fux)] animate-pulse" />{city}
            </span>
          ) : (
            <span key={i} data-testid={`clock-${city.replace(/[^A-Z]/g, "").toLowerCase()}`} className="mono text-[12px] text-[rgba(16,16,20,0.8)] pr-8 shrink-0 whitespace-nowrap">
              <span className="font-semibold">{city}</span> <span className="text-[rgba(16,16,20,0.6)]">{fmt(tz)}</span>
            </span>
          )
        )}
      </div>
    </div>
  );
};

const NewsTicker = () => {
  const { t } = useLang();
  const half = [0, 1, 2, 3];
  return (
    <button type="button" data-testid="news-ticker" onClick={() => scrollToId("news")}
      className="news-ticker-band marquee-wrap mt-3 block w-full overflow-hidden">
      <div className="marquee-track py-1.5" style={{ animationDuration: "26s" }}>
        {[0, 1].map((h) =>
          half.map((i) => (
            <span key={`${h}-${i}`} className="mono text-[11px] uppercase tracking-[0.18em] text-[var(--ink)] flex items-center gap-4 lg:gap-5 pr-4 lg:pr-5 shrink-0 whitespace-nowrap">
              {t.global.newsTicker}<Star className="text-[var(--amber-2)]" />
            </span>
          ))
        )}
      </div>
    </button>
  );
};

export const Marquee = () => {
  const items = [...CITIES, ...CITIES];
  return (
    <section data-testid="marquee-section" className="marquee-wrap relative py-6 lg:py-8 border-b border-[rgba(16,16,20,0.1)] overflow-hidden bg-[var(--bone)]">
      <div className="marquee-track" style={{ animationDuration: "55s" }}>
        {items.map((c, i) => (
          <span key={i} className="flex items-center gap-5 lg:gap-7 pr-5 lg:pr-7">
            <span className="relative w-52 h-32 lg:w-72 lg:h-44 overflow-hidden rounded-[4px] shrink-0">
              <img src={c.src} alt={c.label} className="w-full h-full object-cover" loading="lazy" />
              <span className="absolute bottom-2 left-2 mono text-[10px] uppercase text-[var(--bone)] bg-[#16265c]/75 backdrop-blur px-2 py-0.5 rounded-sm">{c.label}</span>
            </span>
            <Star />
          </span>
        ))}
      </div>
      <Clocks />
      <NewsTicker />
    </section>
  );
};
